import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import TextField from '@mui/material/TextField';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { findSalasGroup } from "./SalaParticipante/api-sala-participante";
import { useNavigate } from 'react-router-dom';

import { RESPONSAVEL, ALUNO } from '../Usuario/Perfil';
import { useSelector } from 'react-redux';
import Loading from '../UI/Loading';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { TablePagination } from '@mui/material';
import TablePaginationActions from '../../shared/components/Table/Actions';
import { dateTimeFormat } from '../../util/DateUtil';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    formulario: {
        marginBottom: '20px'
    }
});


export default function MensagemFindGroup() {
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);
    const [search, setSearch] = useState();
    const [salas, setSalas] = useState({
        content: [],
        totalElements: 0,
        size: 0,
        number: 0

    });
    const history = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const isAll = useSelector(state => state.isAllMensagemTable);

    const handleChange = (event) => {
        setSearch(event.target.value);
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        fetchData(0);
    }

    const fetchData = (selectPage) => {
        setIsLoading(true);
        findSalasGroup(search, selectPage, isAll).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                setSalas(data);
            }
            setIsLoading(false);
        });
    }

    const handleSelectedUser = (sala) => {
        history('/sala-mensagem', { state: { sala: sala } })
    }

    const handleChangePage = (event, newPage) => {
        fetchData(newPage);
    };

    return (
        <>
            {isLoading ?
                <Loading description='Carregando Grupos...' />
                :
                <>
                    {usuario && usuario.perfil !== RESPONSAVEL && usuario.perfil !== ALUNO ?
                        <form className={classes.formulario} onSubmit={clickSubmit}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Descrição"
                                name="descricao"
                                onChange={handleChange}
                                value={search ? search : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 60 }
                                }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Buscar
                            </Button>
                        </form> : ''}

                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Descrição</TableCell>
                                <TableCell>Data Hora Última Mensagem</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {salas && salas.content.map((sala, index) => (
                                <TableRow
                                    key={index}
                                >
                                    <TableCell>
                                        {sala && sala.descricao ? sala.descricao : ''}
                                    </TableCell>
                                    <TableCell>
                                        {sala && sala.dataHoraUtlimaMensagem ?
                                            dateTimeFormat(sala.dataHoraUtlimaMensagem) : ''}
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className={classes.submit}
                                            onClick={() => handleSelectedUser(sala)}
                                        >
                                            Selecionar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        rowsPerPage={salas.size ? salas.size : 0}
                        component="div"
                        count={salas.totalElements}
                        page={salas.number}
                        onPageChange={handleChangePage}
                        labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : " mais de " + to))}
                        ActionsComponent={TablePaginationActions}
                    />
                </>

            }
        </>
    );
}